import { formatINR } from "@/lib/quotationApi";

export default function QuickAddList({ quickItems, findQuick, setQuickQty }) {
  if (quickItems.length === 0) return null;
  return (
    <div className="card-luxe mb-4">
      <div className="overline text-white/50 mb-4">Quick add</div>
      <div className="space-y-3">
        {quickItems.map((q) => {
          const existing = findQuick(q.name);
          const qty = existing?.quantity || 0;
          const testId = q.name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
          return (
            <div
              key={q.id}
              className="flex items-center justify-between gap-3 p-3 rounded-xl bg-white/[0.02] border border-white/5"
              data-testid={`quick-${testId}`}
            >
              <div>
                <div className="font-medium text-[15px]">{q.name}</div>
                <div className="text-xs text-white/40">
                  {formatINR(q.price_per_unit)} each
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="w-10 h-10 rounded-lg border border-white/10 text-white/80 hover:border-[#C5A880] hover:text-[#C5A880] font-semibold"
                  onClick={() => setQuickQty(q.name, qty - 1)}
                  data-testid={`quick-${testId}-minus`}
                >
                  −
                </button>
                <input
                  className="input-luxe !h-10 !w-16 text-center !px-1"
                  type="number"
                  inputMode="numeric"
                  value={qty}
                  onChange={(e) =>
                    setQuickQty(q.name, parseFloat(e.target.value) || 0)
                  }
                  data-testid={`quick-${testId}-input`}
                />
                <button
                  className="w-10 h-10 rounded-lg border border-[#C5A880]/40 bg-[#C5A880]/10 text-[#C5A880] font-semibold hover:bg-[#C5A880]/20"
                  onClick={() => setQuickQty(q.name, qty + 1)}
                  data-testid={`quick-${testId}-plus`}
                >
                  +
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
